import React from 'react';
import { useSpinradContext } from '../../context/SpinradContext';
import { ToastBox } from './styles';

const Toast: React.FC = () => {
  const { toast } = useSpinradContext();

  return (
    <ToastBox $visible={toast.visible}>
      <span>{toast.message}</span>
    </ToastBox>
  );
};

export default Toast;
